module.exports = __webpack_public_path__ + "static/media/user-photo.9e95577a.svg";